import { render, staticRenderFns } from "./AddCapitulo.vue?vue&type=template&id=04273f13&scoped=true"
import script from "./AddCapitulo.vue?vue&type=script&lang=js"
export * from "./AddCapitulo.vue?vue&type=script&lang=js"
import style0 from "./AddCapitulo.vue?vue&type=style&index=0&id=04273f13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04273f13",
  null
  
)

export default component.exports